export default "__VITE_ASSET__407c2eca__"